// Modules chargés uniquement pour leurs effets de bord (window.X), sans dépendance
// directe depuis ce fichier. Le graphe de dépendances ES module garantit maintenant
// que chaque module est chargé et exécuté avant tout module qui en dépend,
// éliminant le besoin d'un ordre de concaténation précis dans gulpfile.js.
import "./modules/a11y.js";
import "./modules/numericInputGuard.js";
import "./modules/csvExporter.js";
import "./data/dataExchange.js";
import "./search/simpleSearchResult.js";
import "./data/indexedDB.js";
import "./results/resultats.js";
import "./ui/datePicker.js";
import "./ui/accordeonFilters.js";
import "./ui/suiviInteractions.js";
import "./ui/setupFiltres.js";
import "./ui/rechercheMobile.js";
import initListPicker from "./search/steps-list-results.js";

document.addEventListener("DOMContentLoaded", () => {
  console.log("Initialisation version 2026-08-26.");
  window.listPickerInstance = initListPicker();
});
